import React, { useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@prio365/prio365-react-library';
import { Navigate, useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  getContactRedirect,
  getContactsDrawerState,
  RootReducerState,
} from '../../../apps/main/rootReducer';
import ContactDetails from './ContactDetails';
import { makePrioStyles } from '../../../theme/utils';
import { InternalContact, ExternalContact } from '../../../models/Contact';
import PrioSpinner from '../../../components/PrioSpinner';
import { setContactsDrawerState } from '../actions/drawer';
import useContactsContext from '../hooks/useContactsProvider';
import { apiFetchContact } from '../api';
import { updateContactInStore } from '../actions';

const useStyles = makePrioStyles((theme) => ({
  root: {},
  noPadding: {
    backgroundColor: theme.old.palette.backgroundPalette.content,
  },
  contactDetails: {
    height: '100%',
    overflow: 'hidden',
  },
}));
interface ContactDetailsPageProps {
  noPadding?: boolean;
  backButton?: boolean;
}

export const ContactDetailsPage: React.FC<ContactDetailsPageProps> = (
  props
) => {
  //#region ------------------------------ Defaults
  const classes = useStyles();
  const { t } = useTranslation();
  const { contactId } = useParams();
  const navigate = useNavigate();
  const { noPadding, backButton } = props;

  const dispatch = useDispatch();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  const { getContactById } = useContactsContext();
  const contact = useMemo(() => {
    return getContactById(contactId);
  }, [contactId, getContactById]);
  const redirect = useSelector<RootReducerState, string>((state) =>
    getContactRedirect(state, contactId)
  );

  const { changedContact } = useSelector(getContactsDrawerState);
  //#endregion

  //#region ------------------------------ Methods / Handlers
  const goBack = () => navigate(-1);
  //#endregion

  //#region ------------------------------ Effects
  useEffect(() => {
    const fecthContact = async () => {
      const { result, data } = await apiFetchContact(contactId);
      if (result.status >= 200 && result.status < 300) {
        dispatch(updateContactInStore(data));
      }
    };
    fecthContact();
  }, [contactId, dispatch]);

  useEffect(() => {
    if (contact && changedContact) {
      dispatch(setContactsDrawerState({ changedContact: null }));
    }
  }, [contact, changedContact, dispatch]);
  //#endregion

  if (redirect) {
    return <Navigate to={`../../${redirect}/details`} />;
  }

  if (contact) {
    return (
      <>
        {backButton && (
          <Button
            onClick={goBack}
            type="link"
            iconProp={['fal', 'chevron-left']}
          >
            {t('common:back')}
          </Button>
        )}
        <ContactDetails
          contactId={contactId}
          contact={contact as InternalContact & ExternalContact}
          className={classNames(classes.contactDetails, {
            [classes.noPadding]: noPadding,
          })}
        />
      </>
    );
  }

  return (
    <div className="prio-flex-center-center prio-flex-column prio-container-fullscreen-height">
      <PrioSpinner size="large" />
    </div>
  );
};

export default ContactDetailsPage;
